import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-rate-text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ant-rate-text" }

import { computed, ref } from 'vue'
import baseMessage from '../components/baseMessage.vue'
import commentList from '../components/commentList.vue'
import Editor from '@/components/Editor'
import UploadFile from '@/components/UploadFile'
import { DcMessage } from '@dc-platform/dc-components'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { AccompanyingVisitComment, AccompanyingVisitDetail } from '@/typings/api/yuntuSales'
import {
  accompanyingVisitComment,
  accompanyingVisitCreate,
  accompanyingVisitUpdate
} from '@/api/yuntuSales/superivisorAccompanyingVisit'
import { goBack } from '@/hooks/cosRouter'
import { FormInstance } from 'ant-design-vue'


const __default__ = {
  name: 'DcCosLbuSupervisorAccompanyingVisitComment'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    default: String
  }
},
  setup(__props) {

const router = useRouter()
const route = useRoute()
const form = ref<AccompanyingVisitComment>({
  fileId: []
})
const detail = ref<AccompanyingVisitDetail>({})

const commentDesc = ref<string[]>(['非常不满意', '不满意', '一般', '满意', '非常满意'])

const props = __props
const activeKey = ref('base')
const loading = ref(false)
const commentListRef = ref()
const formRef = ref<FormInstance>()
const showComment = ref(false)
const commentComputed = computed(() => {
  if (props.type === 'comment') {
    return true
  }
  return showComment.value
})
const editRow = () => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/edit',
    query: {
      id: route.query.id
    }
  })
}
// 评论
const commentRow = () => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/comment',
    query: {
      id: route.query.id
    }
  })
}
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...detail.value
    }
    try {
      if (props.type === 'edit') {
        await accompanyingVisitUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await accompanyingVisitCreate(p)
        DcMessage.success('新增成功')
      }
      goBack()
    } catch (error) {
    }
    loading.value = false
  })
}
const handleCommit = () => {
  if (!form.value.content) {
    DcMessage.warning('请输入评论内容')
    return
  }
  loading.value = true
  // 评论必填
  accompanyingVisitComment(form.value)
    .then((res) => {
      DcMessage.success('发表成功')
      layoutTags.close()
    })
    .finally(() => {
      loading.value = false
    })
}
const getDetail = (data: AccompanyingVisitDetail) => {
  detail.value = data
  form.value.accompanyId = data.id
  form.value.score = data.score
}

return (_ctx: any,_cache: any) => {
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(baseMessage, {
                disabled: true,
                view: "",
                onGetDetail: getDetail
              }),
              _createVNode(_component_dc_layout_card, {
                title: "评论记录",
                isAutoLayout: false
              }, {
                default: _withCtx(() => [
                  (detail.value.score > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        _createVNode(_component_a_rate, {
                          style: {"margin-bottom":"16px","margin-top":"-10px"},
                          value: detail.value.score,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((detail.value.score) = $event)),
                          tooltips: commentDesc.value,
                          disabled: true
                        }, null, 8, ["value", "tooltips"]),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(commentDesc.value[detail.value.score - 1]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(commentList, {
                    ref_key: "commentListRef",
                    ref: commentListRef,
                    permissionPage: {
            delComment: __props.type === 'view' ? 'lbu_accompanying_visit_del_comment' : 'lbu_accompanying_visit_del_comment'
          },
                    data: detail.value.commentList,
                    id: _unref(route).query.id
                  }, null, 8, ["permissionPage", "data", "id"])
                ]),
                _: 1
              }),
              (commentComputed.value)
                ? (_openBlock(), _createBlock(_component_a_form, {
                    key: 0,
                    name: "detailsForm",
                    ref_key: "formRef",
                    ref: formRef,
                    model: form.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_dc_layout_card, { title: "评论" }, {
                        default: _withCtx(() => [
                          (detail.value.score <= 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _createVNode(_component_a_rate, {
                                  style: {"margin-left":"20px","margin-bottom":"16px","margin-top":"-10px"},
                                  value: form.value.score,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.score) = $event)),
                                  tooltips: commentDesc.value,
                                  disabled: detail.value.score > 0
                                }, null, 8, ["value", "tooltips", "disabled"]),
                                _createElementVNode("span", _hoisted_4, _toDisplayString(commentDesc.value[form.value.score - 1]), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Editor), {
                                value: form.value.content,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.content) = $event)),
                                maxlength: 3000,
                                mention: form.value.userCodes,
                                "onUpdate:mention": _cache[3] || (_cache[3] = ($event: any) => ((form.value.userCodes) = $event)),
                                placeholder: "请输入评论"
                              }, null, 8, ["value", "mention"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_dc_form_item, {
                            label: "上传附件",
                            name: "fileId",
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(UploadFile), {
                                value: form.value.fileId,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.fileId) = $event)),
                                valueType: "array"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_cos_footer_button, {
            loading: loading.value,
            hideOk: ""
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: handleCommit,
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("发表 ")
                ]),
                _: 1
              }, 8, ["loading"])), [
                [_vShow, commentComputed.value && activeKey.value === 'base'],
                [_directive_permission, 'lbu_accompanying_visit_comment_btn']
              ]),
              (props.type === 'add' || props.type === 'edit')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSubmit())),
                    loading: loading.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存 ")
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true),
              (props.type === 'view')
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    onClick: editRow
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 编辑 ")
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'lbu_accompanying_visit_edit_btn']
                  ])
                : _createCommentVNode("", true),
              (props.type === 'view')
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    onClick: commentRow
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 评论 ")
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'lbu_accompanying_visit_comment_btn']
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})